import { INTERNSHIPS_MANAGER } from './actionsType'

const { SET_REFUSED_INTERNSHIP } = INTERNSHIPS_MANAGER

const INITIAL_STATE = {
  refusedInternship: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_REFUSED_INTERNSHIP: {
      return { ...state, refusedInternship: action.payload }
    }
    default:
      return state
  }
}
